<template>
    <el-row ref="pdfReviewRef" class="pdf-review">
        <el-col :span="24">
            <el-row>
                <el-col style="display:flex;justify-content: center;">
                    <img src="../../assets/logo_invoice.png" />
                </el-col>
                <el-col>
                    <h1 style="text-align: center;">Invoice</h1>
                </el-col>
                <el-col>
                    <p>linkwink Limited</p>
                    <p>RM 509, 5/F THE CLOUD 111 ,TUNG CHAU ST TAI KOK TSUI ,HONG KONG</p>
                    <p>Zip code: 999077</p>
                    <p>Tax No. 80338285</p>
                    <p>Contact: penny@linkwink.net</p>
                    <p>Tel: +86 13726239879</p>
                    <p>Director: yiying peng</p>
                </el-col>
                <el-col>
                    <p>&nbsp;</p>
                    <p>Billing to:</p>
                    <p v-html="advInfo.billing_info"></p>
                </el-col>
                <el-col>
                    <p>&nbsp;</p>
                    <p>Billing currency: {{ invoiceObj[invoiceType].icontext }}</p>
                    <p>Invoice Date: {{ nowDate }}</p>
                    <p>Invoice No: {{ invoiceNo }}</p>
                    <p>Item: Mobile Advertising Services</p>
                    <p></p>
                </el-col>
                <el-col>
                    <el-table
                        :data="exportList"
                        style="width:100%;"
                        stripe
                        border
                        class="export-list-table"
                        cell-class-name="export-list-table-cell"
                        header-row-class-name="export-list-table-header"
                    >
                        <el-table-column prop="time" label="Month" align="center" />
                        <el-table-column prop="confirm_amount" align="center" :label="`Amount(${invoiceObj[invoiceType].iconText})`" />
                    </el-table>
                </el-col>
                <el-col>
                    <div >
                        <p>&nbsp;</p>
                        <p>Payment details:</p>
                        <p>Bank info:</p>
                        <p>Account name: linkwink Limited</p>
                        <p>Bank account number: 47411965716</p>
                        <p>Bank code: 003</p>
                        <p>Branch code: 474</p>
                        <p>SWIFT code: SCBLHKHH</p>
                        <p>Bank name: Standard Chartered Bank (Hong Kong) Ltd</p>
                        <p>Bank address: 32nd Floor, 4-4A Des Voeux Road Central Hong Kong SAR</p>
                    </div>
                    <div class="invoice-img">
                        <img src="../../assets/invoice.png" width="544px" />
                    </div>
                </el-col>
            </el-row>
        </el-col>
        <el-col>
        </el-col>
    </el-row>
</template>

<script>
export default {
    props: {
        invoiceType: {
            type: String,
        },
        advInfo: {
            type: Object,
        },
        exportList: {
            type: Array,
        },
        nowDate: {
            type: String,
        },
        invoiceNo: {
            type: String,
        }
    },
    data() {
        return {
            invoiceObj: {
                'USD': {
                    iconText: 'USD',
                    icon: '$',
                    emailBody: `
Hello Team,

Please check attached of {invoice_name},please let me know if you have any questions. Below please find payment details:

Account name: linkwink Limited

Thanks!

Best Regards,
linkwink`
                },
                'EUR': {
                    iconText: 'EUR',
                    icon: '€',
                    emailBody: `
Hello Team,

Please check attached of {invoice_name},please let me know if you have any questions. Below please find payment details:

Account name: linkwink Limited

Thanks!

Best Regards,
linkwink`
                },
            },
        }
    }
}
</script>
<style scoped>
.pdf-review {
    padding: 100px 120px;
    color: #000;
    position: relative;
    font-family: Arial !important;
    :deep() {
        p {
            font-size: 18px;
            margin: 12px 0;
        }
    }
    .sub-title {
        font-size: 26px !important;
        font-weight:700;
    }
    
}
.invoice-img {
    text-align: right;
}
.pdf-title {
    /* font-size: 46px; */
    font-size: 48px !important;
    font-weight: 800;
}
</style>
<style>
.export-list-table-cell {
    font-size: 18px;
}
.export-list-table-header >th {
    background-color: #3d98e3;
    color: #fff;
    font-size: 18px;
    font-weight: 800;
}
</style>